export default __webpack_public_path__ + "static/media/introduce_show_1.fe59e4e7.png";